<template>
  <div id="app" :class="{ mask: closeTip }">
    <div class="header">
      <img class="close-img" :src="closeImage" alt="" @click="goBack" />
      {{ $t("OffLinePage.title") }}
    </div>

    <div
      :class="{ 'fanyi-service': true, isActive: active }"
      :style="{ height: height1 }"
    >
      <div class="fanyi-service-left">
        <div class="item1">
          <img class="offline-img" :src="offlineImage" alt="" />
          {{ $t("OffLinePage.title") }}
        </div>
        <div class="item2">{{ $t("OffLinePage.NoInternet") }}</div>
        <div class="item3" v-if="price">
          <span>{{ $t("OffLinePage.RMB") }}{{ price }}</span>
        </div>
      </div>
      <div class="fanyi-service-right">
        <div>
          <img
            class="scan-img"
            :src="scanImage"
            alt=""
            :style="{ marginTop: marginTop }"
          />
        </div>
      </div>
      <div style="height: 20px"></div>
    </div>

    <div :class="{ describe: true, mask: closeTip }">
      <div class="describe-title">
        <div class="describe-title-left">
          {{ $t("OffLinePage.ServiceLife") }}
        </div>
        <div class="describe-title-right">{{ $t("OffLinePage.forever") }}</div>
      </div>
      <div class="line"></div>
      <div class="subscribe">{{ $t("OffLinePage.describe") }}</div>
      <div class="subscribe-content">
        <div>
          {{ $t("OffLinePage.describeItem1") }}
        </div>
        <div>{{ $t("OffLinePage.describeItem2") }}</div>
        <div style="color: #201f34; font-weight: 500">
          {{ $t("OffLinePage.describeItem3") }}
        </div>
      </div>
    </div>

    <div class="count">
      <div class="count-left">{{ $t("OffLinePage.quantity") }}</div>
      <div class="count-right">
        <div>
          <i
            class="el-icon-remove"
            style="font-size: 24px; vertical-align: middle; cursor: pointer"
            @click="handleMinus"
          ></i>
        </div>

        <div class="count-number">{{ countNumber }}</div>
        <div>
          <i
            class="el-icon-circle-plus"
            style="font-size: 24px; vertical-align: middle; cursor: pointer"
            @click="handleAdd"
          ></i>
        </div>
      </div>
    </div>

    <div>
      <el-button class="pay-button" @click="handleConfirm">{{
        $t("OffLinePage.confirm")
      }}</el-button>
    </div>

    <div class="agreement">
      <div><el-checkbox v-model="checked"></el-checkbox></div>
      <div class="agreement-text" @click="handleCheck">
        {{ $t("OffLinePage.popText4") }}
        <a class="agreement-item" @click="toUserAgreement"
          >《{{ $t("OffLinePage.popText2") }}》</a
        >
      </div>
    </div>

    <div class="pop" v-if="closeTip">
      <div class="tip1">
        <div class="pop-title">{{ $t("OffLinePage.popTip") }}</div>
        <div class="offlineClose">
          <img
            class="close-img2"
            :src="offlineCloseImg"
            alt=""
            @click="goBack2"
          />
        </div>
        <div class="pop-content">
          {{ $t("OffLinePage.popText1") }}
          <a class="color1" @click="toUserAgreement"
            >《{{ $t("OffLinePage.popText2") }}》</a
          >
        </div>
        <div class="tip_button">
          <div class="tip_left" @click="handleYes">
            {{ $t("OffLinePage.popText3") }}
          </div>
        </div>
      </div>
    </div>

    <div class="message" v-if="show">
      <div class="tip">{{ message }}</div>
    </div>

    <div class="drawer">
      <el-drawer
        :title="$t('OffLinePage.payType')"
        :visible.sync="drawer"
        :direction="direction"
        :before-close="handleClose"
        size="90%"
        :wrapperClosable="false"
      >
        <div style="padding-bottom: 90px">
          <form id="payment-form" @submit.prevent="handleSubmit">
            <div id="payment-element" />
            <div id="card-errors" class="error" role="alert"></div>
            <button id="submit" class="pay-button" :disabled="isLoading">
              {{ $t("OffLinePage.confirm")
              }}<span v-if="countNumber != 0">¥{{ amount }}</span>
            </button>
          </form>
        </div>
      </el-drawer>
    </div>
  </div>
</template>
  
  <script>
import {  getOrder, getGoods } from "@/api/login/user";
import { loadStripe } from "@stripe/stripe-js";
export default {
  name: "OffLinePage",
  props: {
    id: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      closeTip: false,
      checked: false,
      messages: [],
      productId: "",
      orderNumber: "",
      clientSecret: "",
      publishableKey: "",
      isLoading: false,
      marginTop: "70px",
      height1: "136px",
      card: "",
      term: "",
      safetyCode: "",
      name: "",
      lang: "cn",
      drawer: false,
      direction: "btt",
      show: false,
      message: "",
      amount: 0,
      isCard: false,
      isWx: false,
      isGoogle: false,
      countNumber: 1,
      price: 0,
      active: false,
      queryParams: "",
      env: process.env.VUE_APP_BASE_API,
      closeImage: require("@/assets/close.png"),
      offlineImage: require("@/assets/offline.png"),
      scanImage: require("@/assets/scan.png"),
      cardImage: require("@/assets/card.png"),
      wxImage: require("@/assets/wx.png"),
      googleImage: require("@/assets/google-pay.png"),
      offlineCloseImg: require("@/assets/offline-close.png"),
    };
  },
  watch: {
    lang(val) {
      this.lang = val;
      this.getStyle();
    },
  },
  async mounted() {
    if (localStorage.getItem("lang") === "cn") {
      this.setLanguage();
    }
    this.lang = localStorage.getItem("lang") || "cn";
    this.getStyle();
    this.getGoodsNet();
  },
  methods: {
    handleYes() {
      this.closeTip = false;
      this.checked = true;
      this.handleConfirm();
    },
    toUserAgreement() {
      if (this.lang == "cn") {
        this.$router.push({
          path: "/OffLineAgreement",
        });
      } else {
        this.$router.push({
          path: "/OffLineAgreementEn",
        });
      }
    },
    handleCheck() {
      this.checked = !this.checked;
    },
    setLanguage() {
      let language = this.getPreferredLanguage();

      if (language.startsWith("zh")) {
        localStorage.setItem("lang", "cn");
        this.$i18n.locale = "cn";
        return;
      }
      if (language.startsWith("en")) {
        localStorage.setItem("lang", "en");
        this.$i18n.locale = "en";
        return;
      }
      if (language.startsWith("ja")) {
        localStorage.setItem("lang", "ja");
        this.$i18n.locale = "ja";
        return;
      }
      if (language.startsWith("ko")) {
        localStorage.setItem("lang", "ko");
        this.$i18n.locale = "ko";
        return;
      }
      if (language.startsWith("ru")) {
        localStorage.setItem("lang", "ru");
        this.$i18n.locale = "ru";
        return;
      }
      if (language.startsWith("es")) {
        localStorage.setItem("lang", "es");
        this.$i18n.locale = "es";
        return;
      }
      if (language.startsWith("fr")) {
        localStorage.setItem("lang", "fr");
        this.$i18n.locale = "fr";
        return;
      }
      if (language.startsWith("de")) {
        localStorage.setItem("lang", "de");
        this.$i18n.locale = "de";
        return;
      }
      if (language.startsWith("pt")) {
        localStorage.setItem("lang", "pt");
        this.$i18n.locale = "pt";
        return;
      }
      if (language.startsWith("it")) {
        localStorage.setItem("lang", "it");
        this.$i18n.locale = "it";
        return;
      }
      if (language.startsWith("tr")) {
        localStorage.setItem("lang", "tr");
        this.$i18n.locale = "tr";
        return;
      }
      if (language.startsWith("vi")) {
        localStorage.setItem("lang", "vi");
        this.$i18n.locale = "vi";
        return;
      }
      if (language.startsWith("id")) {
        localStorage.setItem("lang", "id");
        this.$i18n.locale = "id";
        return;
      }
      if (language.startsWith("hi")) {
        localStorage.setItem("lang", "hi");
        this.$i18n.locale = "hi";
        return;
      }
      if (language.startsWith("ar")) {
        localStorage.setItem("lang", "ar");
        this.$i18n.locale = "ar";
        return;
      }
      if (language.startsWith("th")) {
        localStorage.setItem("lang", "th");
        this.$i18n.locale = "th";
        return;
      }
    },
    getPreferredLanguage() {
      return navigator.language || navigator.userLanguage;
    },
    getGoodsNet() {
      const params = {
        product_types: "offline",
      };
      getGoods(params).then((res) => {
        if (!res) return;
        if (res?.data?.lists && res?.data?.lists.length != 0) {
          res?.data?.lists.forEach((item) => {
            this.price = item.price;
            this.amount = this.countNumber * this.price;
            this.productId = item.productId;
          });
        } else {
          this.show = true;
          this.message = this.$t("basePage.error1");
          setTimeout(() => {
            this.show = false;
          }, 1000);
        }
      });
    },
    async getOrderNet() {
      const data = {
        code: "",
        payType: "stripe",
        productId: this.productId,
        types: "onetime",
        count: this.countNumber,
        orderType: "exchange",
      };
      await getOrder(data).then(async(res) => {
        this.clientSecret = res?.data?.paymentParameters;
        this.orderNumber = res?.data?.orderNumber;
        this.publishableKey = res?.data?.publicSecretKey
        localStorage.setItem("orderNumber", this.orderNumber);
        localStorage.setItem("publishableKey", this.publishableKey);
        this.stripe =  await loadStripe(this.publishableKey, {
          locale: this.$i18n.locale == "cn" ? "zh" : this.$i18n.locale, // 绑定当前语言
        });
        if(this.stripe){
          this.init();
        }
      });
    },
    async init() {
      const clientSecret = this.clientSecret;
      const elements = this.stripe.elements({ clientSecret });
      this.elements = elements;
      const options = {
        layout: {
          type: "accordion", // accordion tabs
          defaultCollapsed: true,
          radios: false,
          spacedAccordionItems: true,
        },
      };
      const paymentElement = elements.create("payment", options);
      paymentElement.mount("#payment-element");
      // const linkAuthenticationElement = elements.create("linkAuthentication");
      // linkAuthenticationElement.mount("#link-authentication-element");
      this.isLoading = false;
    },
    async handleSubmit() {
      localStorage.setItem("resultTitle", "离线翻译");
      if (this.countNumber == 0) {
        this.show = true;
        this.message = this.$t("OffLinePage.message1");
        setTimeout(() => {
          this.show = false;
        }, 1000);
        return;
      }
      if (this.isLoading) return;
      this.isLoading = true;
      this.show = true;

      this.message = this.$t("OffLineResult.loading");
      const { error } = await this.stripe.confirmPayment({
        elements: this.elements,
        confirmParams: {
          return_url: `${window.location.origin}/OffLineResult`,
        },
      });
      if (error.type === "card_error" || error.type === "validation_error") {
        this.messages.push(error.message);
        console.log("messages", this.messages);
        this.$message.error(error.message)
        this.show = false;
      } else {
        this.messages.push("An unexpected error occured.");
        this.$message.error("An unexpected error occured.")
        console.log("messages-----------123", this.messages);
        this.show = false;
      }

      this.isLoading = false;
    },
    getStyle() {
      if (this.lang == "cn" || this.lang == "tw") {
        this.height1 = "136px";
      }
      const list = ["en", "ja", "tr", "vi", "hi", "ar", "th"];
      if (list.includes(this.lang)) {
        this.height1 = "148px";
        this.marginTop = "48px";
      }
      if (this.lang == "ru") {
        this.height1 = "164px";
        this.marginTop = "55px";
      }
      if (this.lang == "es") {
        this.height1 = "186px";
        this.marginTop = "70px";
      }
      if (this.lang == "fr") {
        this.height1 = "168px";
      }
      if (this.lang == "de" || this.lang == "id") {
        this.height1 = "170px";
      }
      if (this.lang == "pt") {
        this.height1 = "164px";
      }
      if (this.lang == "it") {
        this.height1 = "156px";
      }
    },
    handleConfirm() {
      if (!this.checked) {
        this.closeTip = true;
        this.checked = true;
        return;
      }
      if (this.countNumber == 0) {
        this.show = true;
        this.message = this.$t("OffLinePage.message1");
        setTimeout(() => {
          this.show = false;
        }, 1000);
        return;
      }
      if (!this.productId) {
        this.show = true;
        this.message = this.$t("basePage.error1");
        setTimeout(() => {
          this.show = false;
        }, 1000);
        return;
      }
      this.drawer = true;
      this.getOrderNet();
    },
    goBack() {
      this.$router.push({
        path: "/RedemptionPage",
      });
    },
    goBack2() {
      this.closeTip = false;
      this.checked = false;
    },
    handleAdd() {
      this.countNumber++;
      this.amount = this.countNumber * this.price;
    },
    handleMinus() {
      if (this.countNumber === 0) return;
      this.countNumber--;
      this.amount = this.countNumber * this.price;
    },
    handlePay(val) {
      if (val === "card") {
        this.isCard = !this.isCard;
        this.isWx = false;
        this.isGoogle = false;
        this.drawer = true;
      }
      if (val === "wx") {
        this.isCard = false;
        this.isWx = !this.isWx;
        this.isGoogle = false;
      }
      if (val === "google") {
        this.isCard = false;
        this.isWx = false;
        this.isGoogle = !this.isGoogle;
      }
    },
    handleClose(done) {
      this.show = false;
      done();
    },
  },
};
</script>
  
  <style scoped>
#app {
  height: 100vh;
  text-align: left;
  padding: 0px 16px;
}
.header {
  height: 44px;
  line-height: 44px;
  font-family: Source Han Sans;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: normal;
  color: #3d3d3d;
  text-align: center;
}
.close-img {
  width: 24px;
  height: 24px;
  float: left;
  padding-top: 10px;
  cursor: pointer;
}
.close-img2 {
  width: 20px;
  height: 20px;
}
.offlineClose {
  position: absolute;
  top: 12px;
  right: 12px;
  cursor: pointer;
}

.fanyi-service {
  width: 100%;
  height: 136px;
  border-radius: 16px;
  background: #e5e5e7;
  margin-top: 16px;
}
.fanyi-service1 {
  width: 100%;
  height: 148px;
  border-radius: 16px;
  background: #e5e5e7;
  margin-top: 16px;
}
.fanyi-service-left {
  float: left;
}
.item1 {
  font-family: PingFang SC;
  font-size: 18px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: normal;
  /* 2-辅色 */
  color: #201f34;
  padding: 16px 16px 8px 16px;
  max-width: 235px;
}
.offline-img {
  width: 32px;
  height: 32px;
  padding-right: 8px;
  vertical-align: middle;
}
.item2 {
  font-family: PingFang SC;
  font-size: 12px;
  font-weight: normal;
  line-height: 16px;
  letter-spacing: normal;
  /* 2-辅字 */
  color: #8e8e8e;
  padding-left: 16px;
  max-width: 238px;
}
.item3 {
  width: 80px;
  height: 32px;
  line-height: 32px;
  border-radius: 8px;
  /* 2-辅色 */
  background: #201f34;
  margin: 16px 0px 0px 16px;

  padding-left: 12px;
  cursor: pointer;

  font-family: Montserrat;
  font-size: 18px;
  font-weight: normal;
  letter-spacing: normal;
  color: #ffffff;
}
.right-img {
  width: 16px;
  height: 16px;
  vertical-align: middle;
}
.fanyi-service-right {
  float: right;
  margin-right: 16px;
}
.icon-right-img {
  width: 16px;
  height: 16px;
}
.right-item1 {
  margin: 22px 0px 32px 32px;
  cursor: pointer;
}
.scan-img {
  width: 50px;
  height: 50px;
  margin-top: 70px;
}
.describe {
  border-radius: 16px;
  /* color-white */
  background: #ffffff;
  margin: 16px 0px;
  height: 250px;
  overflow-y: auto;
}
.describe-title {
  /* display: flex; */
  height: 52px;
  line-height: 52px;
  padding: 0px 16px;
}
.describe-title-left {
  float: left;
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: normal;
  letter-spacing: normal;
  /* 2-辅字 */
  color: #8e8e8e;
}
.describe-title-right {
  float: right;
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: normal;
  letter-spacing: normal;
  /* 2-辅色 */
  color: #201f34;
}
.line {
  width: calc(100% - 32px);
  height: 1px;
  /* 2-底色 */
  border-top: 1px solid #f7f7f7;
  margin: 0px auto 16px;
}
.subscribe {
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  letter-spacing: normal;
  /* 2-辅色 */
  color: #201f34;
  margin-left: 16px;
}
.subscribe-content {
  font-family: PingFang SC;
  font-size: 12px;
  font-weight: normal;
  line-height: 20px;
  letter-spacing: normal;
  /* 2-辅字 */
  color: #8e8e8e;
  margin: 16px;
  padding-bottom: 16px;
}
.count {
  height: 46px;
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: normal;
  line-height: 24px;
  letter-spacing: normal;
  /* 2-辅字 */
  color: #8e8e8e;
}
.count-left {
  float: left;
}
.count-right {
  float: right;
  display: flex;
}
.count-number {
  min-width: 40px;
  font-family: Montserrat;
  font-size: 16px;
  font-weight: normal;
  line-height: 24px;
  letter-spacing: normal;
  color: #3d3d3d;
  text-align: center;
}
.pay-type-title {
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: normal;
  /* 2-辅色 */
  color: #201f34;
  margin: 16px 0px;
}
.line1 {
  width: 100%;
  height: 0px;
  border-top: 1px solid #ebe9e9;
}
.pay-type-content {
  min-width: 120px;
  min-height: 68px;
  border-radius: 8px;
  /* color-white */
  background: #ffffff;
  box-sizing: border-box;
  /* 2-辅色 */
  /* border: 1px solid #201f34; */
  padding: 16px;
  margin-right: 16px;
}
.pay-type-active {
  border: 1px solid #201f34;
}
.pay-type-img {
  width: 20px;
  height: 20px;
}
.pay-type-img1 {
  width: 22px;
  height: 22px;
}
.pay-type-name {
  font-family: PingFang SC;
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: normal;
  /* 2-辅色 */
  color: #201f34;
}
.pay-type {
  display: flex;
  overflow: auto;
  min-height: 70px;
}
.pay {
  margin-top: 16px;
}

.el-button:focus,
.el-button:hover {
  background: #201f34;
  color: #fff;
}

.message {
  width: 100%;
  position: fixed;
  top: 40%;
  left: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  z-index: 9999;
}
.tip {
  min-width: 98px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  align-items: center;
  background: rgba(0, 0, 0, 0.65);
  border-radius: 24px;
  opacity: 1;
  font-family: AlibabaPuHuiTi;
  font-size: 14px;
  font-weight: normal;
  text-align: center;
  letter-spacing: 0em;
  font-feature-settings: "kern" on;
  color: #ffffff;
  padding: 16px 20px;
}
.drawer >>> .el-drawer.btt {
  border-radius: 16px 16px 0px 0px;
  background: #f6f8fa;
  padding: 0px 16px 90px 16px;
}
.drawer >>> .el-drawer__header {
  font-family: Source Han Sans;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  text-align: center;
  letter-spacing: normal;
  /* 2-辅色 */
  color: #201f34;
}
.drawer-item {
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: normal;
  line-height: 24px;
  letter-spacing: normal;
  color: #3d3d3d;
  margin-bottom: 8px;
}
.drawer-input {
  margin-bottom: 16px;
  border-radius: 8px;
  /* color-white */
  background: #ffffff;
}
.drawer-input >>> .el-input__inner {
  border: none;
}
.pay-button {
  width: calc(100% - 32px);
  position: fixed;
  bottom: 44px;
  min-width: 343px;
  height: 44px;
  border-radius: 8px;
  /* 2-辅色 */
  background: #201f34;
  color: #fff;
  margin: 24px 0px;
}
::v-deep .el-drawer__body {
  overflow-x: hidden;
  overflow-y: auto;
}

.agreement {
  position: fixed;
  display: flex;
  bottom: 28px;
}
.agreement-text {
  font-family: PingFang SC;
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: normal;
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 12px;
  font-variation-settings: "opsz" auto;
  color: #8d8d8d;
}
.agreement-item {
  font-family: PingFang SC;
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: normal;
  font-family: PingFang SC;
  font-variation-settings: "opsz" auto;
  font-family: PingFang SC;
  color: #201f34;
  cursor: pointer;
}
::v-deep .el-checkbox__inner {
  border-radius: 50%;
  top: 2px;
  margin-right: 5px;
}

.pop {
  position: fixed;
  top: 40%;
  left: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  z-index: 999;
}
.tip1 {
  position: relative;
  /* 自动布局子元素 */
  width: calc(100% - 64px);
  /* height: 96px; */
  /* 自动布局 */
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  z-index: 999;
  border-radius: 16px;
  /* 卡片色 */
  background: #ffffff;
  /* margin: 0 auto; */

  font-family: AlibabaPuHuiTi;
  font-size: 16px;
  font-weight: normal;
  line-height: 24px;
  text-align: center;
  letter-spacing: 0em;

  font-feature-settings: "kern" on;
  /* 文本色 */
  color: #0e273b;
}
.tip_button {
  display: flex;
  width: 100%;
  text-align: center;
}
.tip_left {
  flex: 1;
  border-radius: 0px 0px 16px 16px;
  /* 卡片色 */
  background: #ffffff;
  box-sizing: border-box;
  /* 背景色 */
  border-width: 1px 1px 0px 0px;
  border-style: solid;
  border-color: #f5f5f5;
  padding: 12px 0px;
  font-family: AlibabaPuHuiTi;
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  text-align: center;
  letter-spacing: normal;
  /* 文本色 */
  color: #0e273b;
}
.tip_right {
  flex: 1;
  border-radius: 0px 0px 16px 0px;
  /* 卡片色 */
  background: #ffffff;
  box-sizing: border-box;
  /* 背景色 */
  border-width: 1px 0px 0px 0px;
  border-style: solid;
  border-color: #f5f5f5;
  padding: 12px 0px;
  font-family: AlibabaPuHuiTi;
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  text-align: center;
  letter-spacing: normal;
  /* 品牌色 */
  color: #f65e3d;
}
.pop-title {
  padding: 24px 24px 0px 24px;
  font-family: Source Han Sans;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  text-align: center;
  letter-spacing: normal;
  color: #201f34;
}
.pop-content {
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  text-align: center;
  letter-spacing: normal;
  color: #8e8e8e;
  padding: 16px 0px 24px;
}
.color1 {
  color: #201f34;
  cursor: pointer;
}
.mask {
  background: rgba(0, 0, 0, 0.1) !important;
}
</style>
  